import { forwardRef, useImperativeHandle, useRef } from "react";
import ManageRecordTags from "./ManageRecordTags";

const TagRecord = (
  {
    tableView,
    mode,
    modifyTrigger,
    tags,
    moduleAPIName,
    recordID,
    field,
    subitemAPIName,
    multiSubitemID,
  },
  ref
) => {
  const tagsRef = useRef();

  useImperativeHandle(ref, () => ({
    focus: () => {
      tagsRef.current.focus();
    },
  }));

  const Tags = (
    <ManageRecordTags
      ref={tagsRef}
      table={tableView}
      moduleAPIName={moduleAPIName}
      recordId={recordID}
      recordTagIds={tags}
      mode={mode}
      modifyTrigger={modifyTrigger}
      full
      subitemAPIName={subitemAPIName}
      multiSubitemID={multiSubitemID}
    />
  );

  return tableView ? Tags : <div className={"px-2"}>{Tags}</div>;
};

export default forwardRef(TagRecord);
